import React from "react";
import { sanDiegoImages } from "../../../utils/imageResources";

import SceneObject from "../../SceneObject";



const LifeguardTower = React.memo(props => {
    return (
        <SceneObject
            name="LifeguardTower"
            transform={{
                position: props.transform.position,
                scale: props.transform.scale,
                rotation: props.transform.rotation,
                opacity: 1
            }}
            $imgUrl={sanDiegoImages.LifeguardTowerImg}
        />
    );
});

export default LifeguardTower;
